(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector/assets/javascripts/api.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector/assets/javascripts/api.js');

'use strict';

const accountSelectorSingleton = new svs.core.Events(new svs.numbergames.accountSelector._internal.AccountSelector());
const api = {
  on(listeners, context) {
    accountSelectorSingleton.listenTo(listeners, context);
  },
  off(listeners) {
    accountSelectorSingleton.stopListeningTo(listeners);
  },
  async fetch(options) {
    return accountSelectorSingleton.fetch(options);
  },
  async getAccounts() {
    return accountSelectorSingleton.getAccounts();
  },
  async getActiveAccount() {
    return accountSelectorSingleton.getActiveAccount();
  },
  async usePlayerAccount() {
    return accountSelectorSingleton.usePlayerAccount();
  },
  async setActiveAccount(activeAccountId) {
    return accountSelectorSingleton.setActiveAccount(activeAccountId);
  },
  async updateAccountBalance(options) {
    return accountSelectorSingleton.updateAccountBalance(options);
  }
};
Object.assign(svs.numbergames.accountSelector, api);

 })(window);